export default __webpack_public_path__ + "static/use-3-mobile-e8a6e73d34bb07d624661a86d8c26430.png";